export default "__VITE_ASSET__a00968f9__"